import Axios from "axios";
import {
  getLcExportDocumentList,
  getLcExportDocumentById,
  saveLcExportDocument,
  updateLcExportDocument,
  getLcExportDocumentResource
} from "@/store/api";
import {
  SET_LC_EXPORT_DOCUMENT_LIST,
  UNSET_LC_EXPORT_DOCUMENT_LIST,
} from "@/store/mutation-types";

const state = {
  lcExportDocumentList: [],
};

const getters = {
  getLcExportDocumentList(state) {
    return state.lcExportDocumentList;
  },
};

const mutations = {
  [SET_LC_EXPORT_DOCUMENT_LIST](state, data) {
    state.lcExportDocumentList = data;
  },
  [UNSET_LC_EXPORT_DOCUMENT_LIST](state) {
    state.lcExportDocumentList = [];
  },
};

const actions = {
  // List
  getLcExportDocumentList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getLcExportDocumentResource)
        .then((response) => {
          if (response.data?.success) {
            commit(SET_LC_EXPORT_DOCUMENT_LIST, response.data.data || []);
          } else {
            commit(UNSET_LC_EXPORT_DOCUMENT_LIST);
          }
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_LC_EXPORT_DOCUMENT_LIST);
          reject(error);
        });
    });
  },

  // Create / Update (with file upload)
  saveUpdateLcExportDocument({ commit }, data) {
    commit("SET_LOADING", { color: "primary" }, { root: true });

    return new Promise((resolve, reject) => {
      const formData = new FormData();

      Object.entries(data).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      const isUpdate = !!data.id;
      let url = getLcExportDocumentResource;
      let method = "post";

      if (isUpdate) {
        url = `${getLcExportDocumentResource}/${data.id}`;
        formData.append("_method", "PUT");
      }

      Axios[method](url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .then(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  // Optional: fetch single document (for edit)
  getLcExportDocumentById(_, id) {
    return Axios.get(`${getLcExportDocumentResource}/${id}`);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};